import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DOWNLOAD_TAGS: TypedDocumentNode<Data, Variables> = gql`
  query downloadTags($domainId: ID!, $tagsType: TagsTypeEnum) {
    downloadTags(domainId: $domainId, tagsType: $tagsType) {
      data
      filename
      type
    }
  }
`
